export const LOW_STOCK = 5;

export function flashInfo(p) {
  if (!p || !p.flash_sale || !p.flash_end || !p.flash_discount) return { active: false, price: p?.price };
  const end = new Date(p.flash_end).getTime();
  if (isNaN(end) || end <= Date.now()) return { active: false, price: p.price };
  const price = Number((p.price * (1 - p.flash_discount / 100)).toFixed(2));
  return { active: true, discount: p.flash_discount, end, original: p.price, price };
}
